import { UserContextType } from './UserContext'
import { useIsCurrentSessionDemo } from '@dtx-company/inter-app/src/redux/selectors/currentSessionSelectors'
import { useRouter } from 'next/router'
import React from 'react'

export function useIsDemo(): boolean {
  const router = useRouter()
  const demo = useIsCurrentSessionDemo()

  return Boolean(demo || router?.query?.demo === 'true')
}

export function useUserContext(): UserContextType {
  const [settings, setSettings] = React.useState({ curTab: 0 })
  const unpublished: Set<string> = new Set<string>()
  const [themeState, setTheme] = React.useState({ unpublished: unpublished })
  const setUserSettings = React.useCallback((currSettings: { curTab: number }): void => {
    setSettings(currSettings)
  }, [])
  const setThemeState = React.useCallback((curTheme: { unpublished: Set<string> }): void => {
    setTheme(curTheme)
  }, [])
  return {
    settings,
    setUserSettings,
    setThemeState,
    themeState
  }
}

export function removeFromThemeState(themeState: Set<string>, pageId: string): Set<string> {
  const newThemeState = themeState
  newThemeState.delete(pageId)
  return newThemeState
}

export function addToThemeState(themeState: Set<string>, pageId: string): Set<string> {
  const newThemeState = themeState
  return newThemeState.add(pageId)
}
